import  ApiService  from '../../services/api.service'
import HashMake from '../../services/hash.service'

const state =  {
    captcha: '',
    canvas: '',
    response: {
        message: '',
        variant: '',
        errmsg: []
    },
    isShow: false,
    loading: false
}

const getters = {
    loading: state => state.loading,
    captcha: (state) => state.captcha,
    canvas: (state) => state.canvas,
    isShow: (state) => state.isShow,
    response: (state) => state.response,
}

const actions = {
    createCaptcha({ commit }) {
        var charsArray =
            "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
        var lengthOtp = 6;
        var captcha = [];
        for (var i = 0; i < lengthOtp; i++) {
            //below code will not allow Repetition of Characters
            var index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
            if (captcha.indexOf(charsArray[index]) == -1) {
                captcha.push(charsArray[index]);
            } else {
                i--
            }
        }
        var canv = document.createElement("canvas");
        canv.id = "captcha";
        canv.width = 100;
        canv.height = 50;
        var ctx = canv.getContext("2d");
        ctx.font = "25px Georgia";
        ctx.strokeText(captcha.join(""), 0, 30);

        //storing captcha so that can validate you can save it somewhere else according to your specific requirements
        let code = captcha.join("");
        commit('setCaptcha', code)
        commit('setCanvas', canv)
    },
    setIsShow({ commit }, value) {
        commit('setIsShow', value)
    },
    sendResetPasswordLink({commit}, formdata) {
        let formData1 = _.clone(formdata, true)
        formData1.email = HashMake.encrypt(formData1.email)

        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            commit('setIsShow', true)
            ApiService.post('/reset-password-link', formData1)
            .then(response => {
                commit('setResponse', response)
                resolve();
            })
            .catch(error => {

                commit('setResetPasswordLinkError', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },
    checkTokenAuthentication({ commit }, formdata) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            ApiService.post('/check-token-authentication', formdata)
                .then(response => {
                    commit('setResponse', response)
                    resolve();
                })
                .catch(error => {
                    commit('setResetPasswordLinkError', error.response.data)
                    reject(error);
                })
                .finally(() => {
                    commit('setLoading', false);
                });
        });
    },
    resetPassword({ commit }, formdata) {
        let lang = formdata.lang;

        let token = formdata.token

        var formData = new FormData()
        formData.append("password", HashMake.encrypt(formdata.password))
        formData.append("email", HashMake.encrypt(formdata.email))
        formData.append("token", token)
        formData.append("lang", lang)

        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            ApiService.post('/reset-password', formData)
                .then(response => {
                    commit('setResetPasswordResponse', response.data)
                    resolve();
                })
                .catch(error => {
                    commit('setResponse', error.response)
                    reject(error);
                })
                .finally(() => {
                    commit('setLoading', false);
                });
        });
    },
    checkVerificationTokenAuthentication({ commit }, formdata) {
        return new Promise((resolve, reject) => {
            ApiService.post('/user/verify', formdata)
                .then(response => {
                    commit('setIsShow', false)
                    commit('setResponse', response.data)
                    resolve();
                })
                .catch(error => {
                    commit('setResponse', error.response.data)
                    reject(error);
                })
        });
    },
    setVerifiedPassword({ commit }, formdata) {
        let password = HashMake.encrypt(formdata.password)
        let lang = HashMake.encrypt(formdata.lang)
        let token = formdata.token

        var formData = new FormData()
        formData.append("password", password)
        formData.append("lang", lang)
        formData.append("token", token)

        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            ApiService.post('/user/setverifiedpassword', formData)
                .then(response => {
                    commit('setResponse', response.data)
                    resolve();
                })
                .catch(error => {
                    commit('setResponse', error.response)
                    reject(error);
                })
                .finally(() => {
                    commit('setLoading', false);
                });
        });
    },
    showError({ commit }, value) {
        commit('setCaptchaError', value)
    },
    resetError({ commit }) {
        commit('resetState')
    }
}

const mutations = {
    setIsShow(state, isShow) {
        state.isShow = isShow
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setResponse(state, data) {
        state.response.errmsg = (data.data && data.data.errors) ? data.data.errors : []; 
        state.response.message = (data.data && data.data.errors) ? "" : data.data;

        if(data.status == 200) {
            state.response.variant = 'success';
        } else {
            state.response.variant = 'danger';
        }
    },
    setResetPasswordResponse(state, data) {

        state.response.message = data.message;
        if(data.status == 200) {
            state.response.variant = 'success';
        } else {
            state.response.variant = 'danger';
        }
    },
    setCaptcha(state, code) {
        state.captcha = code;
    },
    setCanvas(state, canv) {
        state.canvas = canv;
    },
    setError(state, data) {
        
        state.isShow = true;
        state.response.variant = 'danger';
        // state.response.message = data.message;
        state.response.message = data.errors;
        state.response.errmsg = [];
    },
    setCaptchaError(state, data) {
        
        state.isShow = true;
        state.response.variant = 'danger';
        state.response.message = data.msg;
        state.response.errmsg = data.errors;
    },
    setResetPasswordLinkError(state, data) {
        
        state.isShow = true;
        state.response.variant = 'danger';
        state.response.message = data.message;
        state.response.errmsg = [];
    },
    resetState(state) {
        state.isShow = false;
        state.response.variant = '';
        state.response.message = '';
        state.response.errmsg = [];
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}